import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

function pad2(n) {
  return String(n).padStart(2, '0');
}

export default function SidebarCalendar({ collapsed }) {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [month, setMonth] = useState(() => new Date(new Date().getFullYear(), new Date().getMonth(), 1));

  useEffect(() => {
    api.get('/events/occupancy').then((r) => setRows(r.data.events || [])).catch(() => {});
  }, []);

  const byYmd = useMemo(() => {
    const m = {};
    rows.forEach((ev) => {
      const d = new Date(ev.date);
      const k = `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
      if (!m[k]) m[k] = 0;
      m[k] += 1;
    });
    return m;
  }, [rows]);

  if (collapsed) return null;

  const y = month.getFullYear();
  const mo = month.getMonth();
  const firstDow = new Date(y, mo, 1).getDay();
  const dim = new Date(y, mo + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= dim; d++) cells.push(d);

  return (
    <div className="sidebar-cal">
      <div className="sidebar-cal-head">
        <button type="button" className="sidebar-cal-nav" aria-label="Previous month" onClick={() => setMonth(new Date(y, mo - 1, 1))}>
          ‹
        </button>
        <span className="sidebar-cal-title">{month.toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}</span>
        <button type="button" className="sidebar-cal-nav" aria-label="Next month" onClick={() => setMonth(new Date(y, mo + 1, 1))}>
          ›
        </button>
      </div>
      <div className="sidebar-cal-dows">
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((c, i) => (
          <span key={i}>{c}</span>
        ))}
      </div>
      <div className="sidebar-cal-grid">
        {cells.map((day, idx) => {
          if (day === null) return <span key={`e-${idx}`} className="sidebar-cal-cell empty" />;
          const ymd = `${y}-${pad2(mo + 1)}-${pad2(day)}`;
          const n = byYmd[ymd] || 0;
          const today = new Date();
          const isToday =
            today.getFullYear() === y && today.getMonth() === mo && today.getDate() === day;
          return (
            <button
              key={ymd}
              type="button"
              className={`sidebar-cal-cell${n ? ' busy' : ''}${isToday ? ' today' : ''}`}
              onClick={() => navigate(`/calendar?date=${ymd}`)}
              title={n ? `${n} event(s)` : 'Free'}
            >
              {day}
            </button>
          );
        })}
      </div>
      <button type="button" className="sidebar-cal-full" onClick={() => navigate('/calendar')}>
        Open full calendar
      </button>
    </div>
  );
}
